import {
  GET_BOQS,
  GET_BOQ,
  CREATE_BOQ,
  UPDATE_BOQ,
  DELETE_BOQ,
  APPROVE_BOQ,
  CHECK_BOQ,
  GET_BOQ_SUMMARY
} from '../actions/boqActions';

const initialState = {
  boqs: [],
  boq: null,
  summary: null,
  numberOfPages: 0,
  currentPage: 1,
  isLoading: false
};

const boqReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BOQS:
      return {
        ...state,
        boqs: action.payload.boqs,
        numberOfPages: action.payload.totalPages,
        currentPage: action.payload.currentPage,
        isLoading: false
      };
      
    case GET_BOQ:
      return {
        ...state,
        boq: action.payload,
        isLoading: false
      };
      
    case CREATE_BOQ:
      return {
        ...state,
        boqs: [action.payload, ...state.boqs]
      };
      
    case UPDATE_BOQ:
    case APPROVE_BOQ:
    case CHECK_BOQ:
      return {
        ...state,
        boqs: state.boqs.map(boq => 
          boq._id === action.payload._id ? action.payload : boq
        ),
        boq: action.payload
      };
      
    case DELETE_BOQ:
      return {
        ...state,
        boqs: state.boqs.filter(boq => boq._id !== action.payload)
      };
      
    case GET_BOQ_SUMMARY:
      return {
        ...state,
        summary: action.payload,
        isLoading: false
      };
      
    default:
      return state;
  }
};

export default boqReducer;
